import { Button, Modal } from "react-bootstrap";
import './users-in-use.styles.scss';
import UserInfoRow from "../user-info-row/user-info-row.component";

const UsersInUseModal = ({ data, show, onHide, title }) => {
  return (
    <Modal 
      animation={false} 
      dialogClassName="users-in-use-modal" 
      centered 
      scrollable={false}
      show={show} 
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <h2 className="m-0 f-18 f-500">
          {title}
        </h2>
      </Modal.Header>
      <Modal.Body>
        <p className="f-14 f-400 m-0 mb-4">
          {data?.Message}
        </p>
        <ul className="users-list hide-scrollbar">
          {data?.users?.map((user, index) => (
            <UserInfoRow key={index} client={user} />
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UsersInUseModal;
